import { ChatObject } from "../../../services/api/instances/botApi/types";
import type { RootState } from "../../../services/redux/types";
import { createSelector } from "@reduxjs/toolkit";

export const selectChatbotState = (state: RootState) => state.chatbotState;

export const selectChatbotValue = createSelector(
  selectChatbotState,
  (state) => state.chatbotValue,
);

export const selectChats = createSelector(
  selectChatbotState,
  (state) => state.chats,
);

export const makeSelectChatsByRef = (ref: string | null | undefined) => {
  return createSelector([selectChatbotState], (state): ChatObject[] => {
    if (!state?.chats || !ref) {
      return [];
    }

    return state.chats[ref] || [];
  });
};

export const selectLoading = createSelector(
  selectChatbotState,
  (state) => state.isLoading,
);

export const selectMessageLoading = createSelector(
  selectChatbotState,
  (state) => state.isMessageLoading,
);

export const selectChatMessages = createSelector(
  selectChatbotState,
  (state) => state.messages,
);

export const selectDisabled = createSelector(
  selectChatbotState,
  (state) => state.isDisabled,
);
